export function extractOrganizationId(value) {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return null;
    }

    if (/^[a-fA-F0-9]{24}$/.test(trimmedValue)) {
      return trimmedValue;
    }

    try {
      return extractOrganizationId(JSON.parse(trimmedValue));
    } catch {
      return null;
    }
  }

  if (typeof value !== "object") {
    return null;
  }

  if (typeof value.$oid === "string") {
    return value.$oid;
  }

  if (value._id) {
    return extractOrganizationId(value._id);
  }

  if (value.organization) {
    return extractOrganizationId(value.organization);
  }

  if (value.orgId) {
    return extractOrganizationId(value.orgId);
  }

  return null;
}